/**
 * tdesign v1.0.6
 * (c) 2023 TDesign Group
 * @license MIT
 */

var popupProps = {
  attach: {
    type: [String, Function],
    default: "body"
  },
  closeBtn: {
    type: [Boolean, Function]
  },
  closeOnOverlayClick: {
    type: Boolean,
    default: true
  },
  destroyOnClose: Boolean,
  overlayProps: {
    type: Object,
    default: function _default() {
      return {};
    }
  },
  placement: {
    type: String,
    validator: function validator(val) {
      if (!val) return true;
      return ["top", "left", "right", "bottom", "center"].includes(val);
    }
  },
  preventScrollThrough: {
    type: Boolean,
    default: true
  },
  showOverlay: {
    type: Boolean,
    default: true
  },
  transitionName: {
    type: String,
    default: ""
  },
  visible: {
    type: Boolean,
    default: void 0
  },
  modelValue: {
    type: Boolean,
    default: void 0
  },
  defaultVisible: Boolean,
  zIndex: {
    type: Number
  },
  onClose: Function,
  onClosed: Function,
  onOpen: Function,
  onOpened: Function,
  onVisibleChange: Function
};

export { popupProps as default };
//# sourceMappingURL=props.js.map
